import { render, staticRenderFns } from "./CustomerDiscountsPopup.vue?vue&type=template&id=11cfc7bf&"
import script from "./CustomerDiscountsPopup.vue?vue&type=script&lang=js&"
export * from "./CustomerDiscountsPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports